/**
 * Creates a shortId from a UUID by taking the first 10 characters.
 * Used for creating more human-friendly IDs for URLs and references.
 *
 * @param uuid - The UUID to convert to a shortId
 * @returns The first 10 characters of the UUID as a shortId
 */
export function getShortIdFromUuid(uuid: string): string {
  if (!uuid || typeof uuid !== 'string') {
    throw new Error('Invalid UUID provided to getShortIdFromUuid');
  }
  return uuid.slice(0, 10);
}
